// Store original console methods
const originalConsole = {
  log: console.log,
  error: console.error,
  warn: console.warn,
  debug: console.debug,
  info: console.info
};

// Logging state
let isLoggingEnabled = true;

// Override console methods
export const initializeLogger = () => {
  // Log method with timestamp and app prefix
  const createLogMethod = (originalMethod, type) => {
    return (...args) => {
      if (!isLoggingEnabled) return;
      
      originalMethod.call(console, ...args);
    };
  };
/*
  // Override each console method
  console.log = createLogMethod(originalConsole.log, 'log');
  console.error = createLogMethod(originalConsole.error, 'error');
  console.warn = createLogMethod(originalConsole.warn, 'warn');
  console.debug = createLogMethod(originalConsole.debug, 'debug');
  console.info = createLogMethod(originalConsole.info, 'info');
  */
};

// Enable/disable logging
export const enableLogging = () => {
  isLoggingEnabled = true;
  console.log('Logging enabled');
};

export const disableLogging = () => {
  console.log('Logging disabled');
  isLoggingEnabled = false;
};

// Toggle logging
export const toggleLogging = () => {
  isLoggingEnabled = !isLoggingEnabled;
  if (isLoggingEnabled) {
    console.log('Logging enabled');
  }
};

// Get logging state
export const isLoggingActive = () => isLoggingEnabled;

// Reset to original console methods
export const resetLogger = () => {
  console.log = originalConsole.log;
  console.error = originalConsole.error;
  console.warn = originalConsole.warn;
  console.debug = originalConsole.debug;
  console.info = originalConsole.info;
};

// Initialize on import
initializeLogger(); 